import { ObjectMapper } from "json-object-mapper";
import { IModel } from "../IModel";
import { Model } from "../model";
import { TimeOccurrenceSubType } from "services/enums/timeOccurrenceSubType.enum";

export class TimeBonusReasonModel
  extends Model
  implements IModel<TimeBonusReasonModel> {
  companyGroupId: string | undefined = undefined;
  /** Escopo por empresa raiz; vazio = todo o company group */
  companyRootId: string | undefined = undefined;
  /** Escopo por filial; vazio = raiz ou grupo conforme regra de negócio */
  companyId: string | undefined = undefined;
  title: string = "";
  description: string = "";
  integrationCode: string = "";
  order: number = 0;
  requiresDocument: boolean = false;
  entitlementDays: number = 0;
  canApproveWithOddRegistrations: boolean = true;
  isHoursBankRelated: boolean = false;
  subType: string = TimeOccurrenceSubType.Unset.value;

  get subTypeLabel(): string {
    const item = TimeOccurrenceSubType.getBy(this.subType);
    return item ? item.label : '-';
  }

  get subTypeBadge(): string {
    const item = TimeOccurrenceSubType.getBy(this.subType);
    if (!item) return '-';

    return `<span class="badge bg-light-${item.className} rounded-pill text-wrap">${item.label}</span>`;
  }

  static create(input: any): TimeBonusReasonModel {
    return ObjectMapper.deserialize<TimeBonusReasonModel>(
      TimeBonusReasonModel,
      input
    );
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
